webpackJsonp([114276838955818,60335399758886],{

/***/ 74:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(137);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(74);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _universalCookie = __webpack_require__(11);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _universalCookie2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _universalCookie = __webpack_require__(11);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CookiesProvider = function (_Component) {
	  _inherits(CookiesProvider, _Component);
	
	  function CookiesProvider(props) {
	    _classCallCheck(this, CookiesProvider);
	
	    var _this = _possibleConstructorReturn(this, (CookiesProvider.__proto__ || Object.getPrototypeOf(CookiesProvider)).call(this, props));
	
	    if (props.cookies) {
	      _this.cookies = props.cookies;
	    } else {
	      _this.cookies = new _universalCookie2.default();
	    }
	    return _this;
	  }
	
	  _createClass(CookiesProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        cookies: this.cookies
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return CookiesProvider;
	}(_react.Component);
	
	CookiesProvider.propTypes = {
	  children: _propTypes.node,
	  cookies: (0, _propTypes.instanceOf)(_universalCookie2.default)
	};
	CookiesProvider.childContextTypes = {
	  cookies: (0, _propTypes.instanceOf)(_universalCookie2.default).isRequired
	};
	exports.default = CookiesProvider;
	module.exports = exports['default'];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cookies = __webpack_require__(75);
	
	Object.defineProperty(exports, 'Cookies', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cookies).default;
	  }
	});
	
	var _CookiesProvider = __webpack_require__(76);
	
	Object.defineProperty(exports, 'CookiesProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CookiesProvider).default;
	  }
	});
	
	var _withCookies = __webpack_require__(78);
	
	Object.defineProperty(exports, 'withCookies', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withCookies).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withCookies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _universalCookie = __webpack_require__(11);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _hoistNonReactStatics = __webpack_require__(43);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function withCookies(Component) {
	  function Wrapper(props, _ref) {
	    var cookies = _ref.cookies;
	
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(Component, _extends({}, remainingProps, {
	      cookies: cookies,
	      ref: wrappedComponentRef
	    }));
	  }
	
	  Wrapper.displayName = 'withCookies(' + (Component.displayName || Component.name) + ')';
	  Wrapper.WrappedComponent = Component;
	
	  Wrapper.propTypes = {
	    wrappedComponentRef: _propTypes.func
	  };
	
	  Wrapper.contextTypes = {
	    cookies: (0, _propTypes.instanceOf)(_universalCookie2.default).isRequired
	  };
	
	  return (0, _hoistNonReactStatics2.default)(Wrapper, Component);
	}
	module.exports = exports['default'];

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cookie = __webpack_require__(47);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(22);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _utils = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Cookies = function () {
	  function Cookies(cookies, hooks) {
	    _classCallCheck(this, Cookies);
	
	    this.cookies = parseCookies(cookies);
	    this.hooks = hooks;
	    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
	  }
	
	  _createClass(Cookies, [{
	    key: '_updateBrowserValues',
	    value: function _updateBrowserValues() {
	      if (!this.HAS_DOCUMENT_COOKIE) {
	        return;
	      }
	
	      this.cookies = _cookie2.default.parse(document.cookie);
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._updateBrowserValues();
	      return readCookie(this.cookies[name], options);
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this._updateBrowserValues();
	      var result = {};
	
	      for (var name in this.cookies) {
	        result[name] = readCookie(this.cookies[name], options);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'set',
	    value: function set(name, value, options) {
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        value = JSON.stringify(value);
	      }
	
	      if (this.hooks && this.hooks.onSet) {
	        this.hooks.onSet(name, value, options);
	      }
	
	      this.cookies[name] = value;
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, value, options);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove(name, options) {
	      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
	        expires: new Date(1970, 1, 1, 0, 0, 1),
	        maxAge: 0
	      });
	
	      if (this.hooks && this.hooks.onRemove) {
	        this.hooks.onRemove(name, finalOptions);
	      }
	
	      delete this.cookies[name];
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
	      }
	    }
	  }]);
	
	  return Cookies;
	}();
	
	exports.default = Cookies;
	
	
	function parseCookies(cookies) {
	  if (typeof cookies === 'string') {
	    return _cookie2.default.parse(cookies);
	  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
	    return cookies;
	  } else {
	    return {};
	  }
	}
	
	function isParsingCookie(value, doNotParse) {
	  if (typeof doNotParse === 'undefined') {
	    // We guess if the cookie start with { or [, it has been serialized
	    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
	  }
	
	  return !doNotParse;
	}
	
	function readCookie(value) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (isParsingCookie(value, options.doNotParse)) {
	    try {
	      return JSON.parse(value);
	    } catch (e) {
	      // At least we tried
	    }
	  }
	
	  return value;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cookies = __webpack_require__(83);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Cookies2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.hasDocumentCookie = hasDocumentCookie;
	exports.cleanCookies = cleanCookies;
	// Can we get/set cookies on document.cookie?
	
	function hasDocumentCookie() {
	  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
	}
	
	//backwards compatibility
	var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
	
	function cleanCookies() {
	  document.cookie.split(';').forEach(function (c) {
	    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
	  });
	}

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(251);
	
	var _reactCookie = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'span',
	            { style: { display: "none", visibility: "hidden" } },
	            _react2.default.createElement('audio', { id: 'nts-player-audio', preload: 'none', type: 'audio/mpeg', src: '', loop: true })
	        ),
	        _react2.default.createElement(
	            _reactCookie.CookiesProvider,
	            null,
	            children()
	        )
	    );
	};
	
	TemplateWrapper.propTypes = {
	    children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-b6a0251f95af5c0455a8.js